module.exports = __webpack_public_path__ + "static/Untitled-1-07-95a8cb167716197aaf62fcc2cce91e84.jpg";